import "bootstrap/dist/css/bootstrap.css";
import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
} from "react";
import Navbar from "../components/Navbar";
import { FaEye } from "react-icons/fa";
import { FcProcess } from "react-icons/fc";
import { BsArrowDown } from "react-icons/bs";
import { BsArrowLeft } from "react-icons/bs";
import { BsArrowRight } from "react-icons/bs";
import { BsArrowUp } from "react-icons/bs";
import {
  IoMdArrowDropdown,
  IoMdClose,
  IoMdArrowDropright,
} from "react-icons/io";
import { MdDelete } from "react-icons/md";
import {
  sortArrayListAsc,
  sortArrayListDes,
  sortDateArrayListAsc,
  sortDateArrayListDes,
} from "../Utils";
import { useHistory } from "react-router-dom";
import CommanSpinner from "../components/CommanSpinner";
import { ShowPages } from "../variable";
import { useCookies } from "react-cookie";
import { useIdleTimer } from "react-idle-timer";
import { IdealTimeGetFaxCall } from "../variable";
import { DebounceInput } from "react-debounce-input";
import CustomPagination from "../CommonComponents/Pagination";
import { axiosRequest } from "../axiosConfig";
import { faxInboxCacheManager } from "../utils/faxInboxCacheManager";
import qs from "qs";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Popover,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  TableRow,
  Paper,
  Button,
  TextField,
  Stack,
  Typography,
  IconButton,
  Chip,
  Box,
  InputAdornment,
  Pagination,
  MenuItem,
  Link,
  FormControl,
  Select,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  ArrowUpward,
  ArrowDownward,
  Visibility,
  Search,
  FilterList,
  Refresh,
  KeyboardArrowDown,
  KeyboardArrowRight,
  Delete,
  KeyboardArrowLeft,
} from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { isDemo } from "../App";
import { ReactComponent as TrashIcon } from "./Trash Icon.svg";
import { ReactComponent as TrashIconHover } from "./Trash Icon Hover.svg";
import DocumentStatusMonitor from "../components/DocumentStatusMonitor";

const HomePage = () => {
  const [inboxPageState, setInboxPageState] = useState({
    alias: [],
    searchCallerId: "",
    searchFaxId: "",
    searchStatusFilter: "New",
    pageNumber: 1,
  });
  const history = useHistory();
  const [openSplit, setOpenSplit] = useState(false);
  const [deleteBtnPopup, setdeleteBtnPopup] = useState(false);
  const [afterfDeleteChangePopup, setafterfDeleteChangePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const [pageLoader, setPageLoader] = useState("");

  const [actualData, setActualData] = useState([]);
  const [showData, setShowData] = useState([]);
  const [searchVal, setSearchval] = useState("");
  const [aliasSelectedFilter, setAliasSelectedFilter] = useState([]);
  const [drpToggle, setDrpToggle] = useState(false);
  // const [onClickSort,setOnClickSort] = useState(false);

    // Add this state management near your other state declarations
  const [statusFilter, setStatusFilter] = useState("");

  const [pagesArray, setPagesArray] = useState([]);
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const outSideRef = useRef(null);
  const [childPdfArray, setChildPdfArray] = useState([]);
  const [userAdded, setUserAdded] = useState("");
  const [activeSort, setactiveSort] = useState("");
  const [cookies] = useCookies();
  const [selectedAliasToShow, setSelectedAliasToShow] = useState();
  const [aliasCount, setAliasCount] = useState(0);
  const [backendPageSize, setBackendPageSize] = useState(10);
  const sortByList = {
    ReceivedOn: "ReceivedOn",
    Status: "status",
  };
  const orderByList = {
    ASC: "ASC",
    DESC: "DESC",
  };
  const [sortBy, setSortBy] = useState(sortByList.ReceivedOn);
  const [orderBy, setOrderBy] = useState(orderByList.ASC);
  const [makeAPIcall, setMakeAPIcall] = useState("");
  const [searchValOnSearch, setSearchValOnSearch] = useState("null");
  const [faxIdSearchVal, setFaxIdSearchVal] = useState("");
  const [faxIdValOnSearch, setFaxIdValOnSearch] = useState("null");
  const [makeFaxIdAPIcall, setMakeFaxIdAPIcall] = useState("");
  const [selectedChildForDeletion, setSelectedChildForDeletion] =
    useState(null);

  const shouldShowSplit = sessionStorage.getItem("showSplit") == "true";
  const [showSplit, setShowSplit] = useState(shouldShowSplit);

  const shouldShowDemoChild1Completed = sessionStorage.getItem("showDemoChild1Completed") == "true";
  const [demoShowChild1Completed, setShowdemoChild1Completed] = useState(shouldShowDemoChild1Completed)

  const shouldShowDemoChild2Completed = sessionStorage.getItem("showDemoChild2Completed") == "true";
  const [demoShowChild2Completed, setShowdemoChild2Completed] = useState(shouldShowDemoChild2Completed)

  // get the alias list from api and also maintain the state.
  const getAliasList = () => {
    axiosRequest
      .get(`${process.env.REACT_APP_BaseUrl}getaliaslist`)
      .then((res) => {
        let allAlias = [];
        let len = res.data.length;
        for (let i = 0; i < len; i++) {
          let isCheckedValue = false;
          if (history?.location?.state?.indexPageState?.alias?.length > 0) {
            history?.location?.state?.indexPageState?.alias.forEach((elm) => {
              if (elm?.alias == `${res.data[i]}`) {
                isCheckedValue = true;
              }
            });
          }
          let aliasObj = {
            alias: `${res.data[i]}`,
            isChecked: isCheckedValue,
          };
          allAlias.push(aliasObj);
        }
        setAliasSelectedFilter([...allAlias]);
        if (allAlias?.length > 0) {
          let showAlias = "";
          let selectedAlias = allAlias?.filter((item) => {
            if (item.isChecked == true) {
              showAlias =
                (showAlias?.length > 0 ? showAlias + ", " : showAlias) +
                item.alias;
              return item;
            }
          });
          setSelectedAliasToShow(showAlias);
          setAliasCount(selectedAlias?.length);
        }
      })
      .catch((err) => {
        console.log(err, "getaliaslist");
      });
  };

  useEffect(() => {
    setShowSplit(sessionStorage.getItem("showSplit") == "true");
    setShowdemoChild1Completed(sessionStorage.getItem("showDemoChild1Completed") == "true");
    setShowdemoChild2Completed(sessionStorage.getItem("showDemoChild2Completed") == "true");
  }, [sessionStorage])

  // Get the Fax list basis on alias and callerid and page index.

  const [combinedSearchVal, setCombinedSearchVal] = useState("");

  const handleCombinedSearch = (value) => {
    setCombinedSearchVal(value);

    clearTimeout(makeAPIcall);
    setMakeAPIcall(
      setTimeout(() => {
        const alias = aliasSelectedFilter
          .filter((e) => e.isChecked)
          .map((element) => element.alias)
          .join(", ");
        getFaxList(
          alias || "null",
          value || "null",
          value || "null",
          1,
          sortBy,
          orderBy,
          statusFilter
        );


        setSelectedPage(1);
        let inboxPageStateObj1 = { ...inboxPageState };
        inboxPageStateObj1.pageNumber = 1;
        inboxPageStateObj1.searchCallerId = value || "";
        inboxPageStateObj1.searchFaxId = value || "";
        setInboxPageState(inboxPageStateObj1);
      }, 100)
    );
  };


  const processInboxData = (
    data,
    showSplit,
    targetFaxId,
    shouldShowDemoChild1Completed,
    shouldShowDemoChild2Completed
  ) => {
    // If data is null, undefined, or not an object, return it as is
    if (!data || typeof data !== 'object') {
      return data;
    }

    // Create a deep copy to avoid modifying the original data
    const processedData = JSON.parse(JSON.stringify(data));

    // Check if the data has a content property that is an array
    if (Array.isArray(processedData.content)) {
      // Find the specific fax object with the target ID
      const targetFaxIndex = processedData.content.findIndex(fax => fax.id === targetFaxId);

      // If the fax with the target ID is found
      if (targetFaxIndex !== -1) {
        const targetFax = processedData.content[targetFaxIndex];

        // If showSplit is true, empty the childpdf array
        if (!showSplit) {
          if (Array.isArray(targetFax.childpdf)) {
            targetFax.childpdf = [];
          }
        } else {
          // Handle status updates only if childpdf is an array and not empty
          if (Array.isArray(targetFax.childpdf) && targetFax.childpdf.length > 0) {
            // Update first child's status if shouldShowDemoChild1Completed is true
            if (shouldShowDemoChild1Completed && targetFax.childpdf.length >= 1) {
              targetFax.childpdf[0].status = "Completed";
            }

            // Update second child's status if shouldShowDemoChild2Completed is true
            if (shouldShowDemoChild2Completed && targetFax.childpdf.length >= 2) {
              targetFax.childpdf[1].status = "Completed";
            }
          }
        }
      }
    }

    return processedData;
  };



  const getFaxList = async (
    alias,
    callerid,
    faxid = "null",
    pagenum,
    sortBy,
    orderBy,
    status,
  ) => {
    setPageLoader("faxload");

    try {
      let statusFilter = status ?? "null";
      if (status && status.length < 1) {
        statusFilter = "null";
      } else if (!status) {
        statusFilter = "null";
      }

      // Get data using cache manager
      let actualArrayRes = await faxInboxCacheManager.getFaxInboxData(
        alias,
        callerid,
        faxid,
        pagenum,
        statusFilter,
        sortBy,
        orderBy,
      );

      if(isDemo){
        const targetFaxId = "UNc2560210da2bc9cac7e421034bbdd902";
        actualArrayRes = processInboxData(
          actualArrayRes,
          showSplit,
          targetFaxId,
          shouldShowDemoChild1Completed,
          shouldShowDemoChild2Completed
        );
      }

      if (actualArrayRes?.pageable?.pageSize) {
        setBackendPageSize(actualArrayRes.pageable.pageSize);
      }

      setPageLoader("");
      let actualArray = [];
      let len = actualArrayRes?.content?.length;

      function formatDate(date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        let strTime = hours + ":" + minutes + " " + ampm;
        let month = date.getMonth() + 1;
        month = month % 12;
        month = month ? "0" + month : "12";
        let date1 = date.getDate();
        date1 = "0" + date1;
        return (
          month?.slice(-2) +
          "-" +
          date1?.slice(-2) +
          "-" +
          date?.getFullYear() +
          " " +
          strTime
        );
      }

      for (let i = 0; i < len; i++) {
        let callerIdNum = `${
          actualArrayRes?.content[i]?.callerId
            ? actualArrayRes?.content[i]?.callerId
            : ""
        }`;
        let calleridFormat = `(${callerIdNum?.slice(
          0,
          3,
        )}) ${callerIdNum?.slice(3, 6)}-${callerIdNum?.slice(
          6,
          callerIdNum?.length,
        )}`;

        let faxLineNum = `${
          actualArrayRes?.content[i]?.faxLine
            ? actualArrayRes?.content[i]?.faxLine
            : ""
        }`;
        let faxLineFormat = `(${faxLineNum?.slice(0, 3)}) ${faxLineNum?.slice(
          3,
          6,
        )}-${faxLineNum?.slice(6, faxLineNum?.length)}`;

        actualArray.push({
          Id: `${
            actualArrayRes?.content[i]?.id ? actualArrayRes?.content[i]?.id : ""
          }`,
          ReceivedOn: `${
            actualArrayRes?.content[i]?.receivedOn
              ? formatDate(new Date(actualArrayRes?.content[i]?.receivedOn))
              : ""
          }`,
          Pages: `${
            actualArrayRes?.content[i]?.pageCount
              ? actualArrayRes?.content[i]?.pageCount
              : ""
          }`,
          Status: `${
            actualArrayRes?.content[i]?.status
              ? actualArrayRes?.content[i]?.status
              : ""
          }`,
          CallerId: `${calleridFormat}`,
          FaxLine: `${faxLineFormat}`,
          FaxId: `${
            actualArrayRes?.content[i]?.faxId
              ? actualArrayRes?.content[i]?.faxId
              : ""
          }`,
          Name: `${
            actualArrayRes?.content[i]?.location?.name
              ? actualArrayRes?.content[i]?.location?.name
              : ""
          }`,
          Alias: `${
            actualArrayRes?.content[i]?.alias
              ? actualArrayRes?.content[i]?.alias
              : ""
          }`,
          ProcessedBy: `${
            actualArrayRes?.content[i]?.processed_by
              ? actualArrayRes?.content[i]?.processed_by
              : ""
          }`,
          ChildPdf: !actualArrayRes?.content[i]?.childpdf
            ? []
            : actualArrayRes?.content[i]?.childpdf,
          Locked: actualArrayRes?.content[i].locked,
        });
      }

      setActualData(actualArray);
      if (combinedSearchVal) {
        setShowData(actualArray);
      } else {
        setShowData(actualArray);
      }
      setTotalElements(actualArrayRes?.totalElements);
      setTotalPages(actualArrayRes?.totalPages);
    } catch (err) {
      setPageLoader("");
      console.error("Error in getFaxList:", err);
    }
  };

  useEffect(() => {
    // if the user has already state of inbox then if condition wrote.

    console.log("Initial useEffect")

    if (userAdded == "true") {
      let InboxPageState = history?.location?.state?.indexPageState;
      console.log("InboxPageState ", InboxPageState);
      if (
        InboxPageState &&
        (InboxPageState.alias?.length > 0 ||
          InboxPageState.searchCallerId?.length > 0 ||
          InboxPageState.searchFaxId?.length > 0 ||
          InboxPageState.pageNumber > 1 ||
          (InboxPageState.sortBy &&
            InboxPageState.sortBy != sortByList.ReceivedOn) ||
          (InboxPageState.orderBy && InboxPageState.orderBy != orderByList.ASC))
      ) {
        let searchText = "null";
        let faxIdText = "null";
        let aliasStringList = "null";
        let pageNumber = 1;
        if (InboxPageState.alias?.length > 0) {
          let alias = [...InboxPageState.alias];
          alias = alias.filter((e) => {
            return e.isChecked == true;
          });
          aliasStringList = alias
            ?.map(function (element) {
              return element.alias;
            })
            .join(", ");
        }
        // if (InboxPageState.searchCallerId?.length > 0) {
        //   searchText = InboxPageState.searchCallerId;
        // }
        // if (InboxPageState.searchFaxId?.length > 0) {
        //   faxIdText = InboxPageState.searchFaxId;
        // }
        if (InboxPageState.pageNumber > 1) {
          pageNumber = InboxPageState.pageNumber;
        }
        getFaxList(
          aliasStringList,
          searchText,
          faxIdText,
          pageNumber,
          InboxPageState.sortBy,
          InboxPageState.orderBy,
          InboxPageState.searchStatusFilter
        );
        setSearchval(searchText == "null" ? "" : searchText);
        setFaxIdSearchVal(faxIdText == "null" ? "" : faxIdText);
        setSortBy(InboxPageState.sortBy);
        setOrderBy(InboxPageState.orderBy);
        setSelectedPage(InboxPageState.pageNumber);
        setStatusFilter(InboxPageState.searchStatusFilter);
        setInboxPageState(history?.location?.state?.indexPageState);
      } else {
        getFaxList("null", "null", "null", selectedPage, sortBy, orderBy);
        setInboxPageState({
          alias: [],
          searchCallerId: "",
          searchStatusFilter: statusFilter,
          searchFaxId: "",
          pageNumber: 1,
          sortBy: sortBy,
          orderBy: orderBy,
        });
      }
      getAliasList();
    }
  }, [userAdded == "true"]);

  // Validate the user and redrirect to the url;
  useEffect(() => {
    console.log(cookies);
    if (cookies?.firstName) {
      setUserAdded("true");
    }
  }, []);

  // Drop down auto close event bind and unbind.
  useEffect(() => {
    function handleClickOutside(event) {
      if (outSideRef.current && !outSideRef.current.contains(event.target)) {
        if (drpToggle) {
          setDrpToggle(false);
        }
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("click", handleClickOutside);
    };
  }, [outSideRef, drpToggle]);

  const sortByWithOrder = (sortby, orderby, e) => {
    e?.stopPropagation();
    e?.preventDefault();
    let alias = [...aliasSelectedFilter];
    alias = alias.filter((e) => {
      return e.isChecked == true;
    });
    let aliasStringList = alias
      ?.map(function (element) {
        return element.alias;
      })
      .join(", ");
    getFaxList(
      aliasStringList ? aliasStringList : "null",
      searchVal ? searchVal : "null",
      faxIdSearchVal ? faxIdSearchVal : "null",
      selectedPage,
      sortby,
      orderby,
    );
    setSortBy(sortby);
    setOrderBy(orderby);
  };

  function searchCall(enteredVal) {
    let searchText = enteredVal ? enteredVal?.trim() : "null";
    let alias = [...aliasSelectedFilter];
    alias = alias.filter((e) => {
      return e.isChecked == true;
    });
    let aliasStringList = alias
      ?.map(function (element) {
        return element.alias;
      })
      .join(", ");
    getFaxList(
      aliasStringList ? aliasStringList : "null",
      searchText,
      "null",
      1,
      sortBy,
      orderBy,
    );
    setSelectedPage(1);
    let inboxPageStateObj1 = inboxPageState;
    inboxPageStateObj1.pageNumber = 1;
    inboxPageStateObj1.searchCallerId = searchText;
    inboxPageStateObj1.alias = alias ? alias : [];
    inboxPageStateObj1.sortBy = sortBy;
    inboxPageStateObj1.orderBy = orderBy;
    inboxPageStateObj1.searchStatusFilter = statusFilter;
    setInboxPageState(inboxPageStateObj1);
  }
  useEffect(() => {
    if (searchValOnSearch !== "null") {
      clearInterval(makeAPIcall);
      setMakeAPIcall(
        setTimeout(() => {
          searchCall(searchVal);
        }, 1000),
      );
    }
  }, [searchValOnSearch]);

  const searchRecord = (value) => {
    const numRegex = /^[0-9\b]+$/;
    let enteredVal = "";
    if (value && !numRegex?.test(value?.replace(/[- )(]/g, ""))) {
      setSearchval(searchVal);
      return;
    } else if (
      value &&
      !value?.includes(" ") &&
      !value?.includes("(") &&
      !value?.includes(")") &&
      !value?.includes("-") &&
      numRegex?.test(value?.replace(/[- )(]/g, ""))
    ) {
      enteredVal = value?.slice(0, 10);
    } else if (
      value &&
      value?.replace(/[- )(]/g, "")?.length <= 10 &&
      numRegex?.test(value?.replace(/[- )(]/g, ""))
    ) {
      enteredVal = value;
    } else if (value !== "") {
      return;
    }
    setSearchval(enteredVal?.trim());
    setSearchValOnSearch(enteredVal?.trim());
  };

  const [recentlySplitDocId, setRecentlySplitDocId] = useState(null);

  const handleSplitComplete = (documentId) => {
    // Store the ID of the document that was just split
    setRecentlySplitDocId(documentId);
    // Any other actions you need to take after split is complete
  };

  useEffect(() => {
    // Check if we're coming from a split operation via router state
    const fromSplit = history.location.state?.fromSplit;
    const splitDocId =
      history.location.state?.splitDocumentId ||
      sessionStorage.getItem("recentlySplitDocId");

    // Only proceed if we have data loaded
    if (fromSplit && splitDocId && showData && showData.length > 0) {
      // Find the document in the table data
      const targetDoc = showData.find((pdf) => pdf.Id === splitDocId);

      // If we found the document and it has child PDFs
      if (
        targetDoc &&
        targetDoc.ChildPdf &&
        targetDoc.ChildPdf.length > 0 &&
        targetDoc.ChildPdf.some((el) => !el?.deleted)
      ) {
        // Automatically expand it
        childArrayClick(targetDoc);

        // Clean up router state and sessionStorage
        history.replace({
          pathname: "/home",
          state: {
            ...history.location.state,
            fromSplit: undefined,
            splitDocumentId: undefined,
          },
        });
        sessionStorage.removeItem("recentlySplitDocId");
      }
    }
  }, [showData, history.location]);
  // Cleare the all fiters.
  const clearFilter = () => {
    setCombinedSearchVal("");
    setShowData(actualData);
    setSearchval("");
    // setSearchValOnSearch("");
    setFaxIdSearchVal("");
    setSearchValOnSearch("null");
    setFaxIdValOnSearch("null");
    clearInterval(makeAPIcall);
    clearInterval(makeFaxIdAPIcall);
    let tempAry = [...aliasSelectedFilter];
    tempAry.forEach((e) => {
      return (e.isChecked = false);
    });
    setAliasSelectedFilter(tempAry);
    getFaxList(
      "null",
      "null",
      "null",
      1,
      sortByList.ReceivedOn,
      orderByList.ASC,
    );
    setSelectedPage(1);
    setSortBy(sortByList.ReceivedOn);
    setOrderBy(orderByList.ASC);
    let inboxPageStateObj1 = inboxPageState;
    inboxPageStateObj1.pageNumber = 1;
    inboxPageStateObj1.searchCallerId = "";
    inboxPageStateObj1.searchFaxId = "";
    inboxPageStateObj1.alias = [];
    inboxPageStateObj1.sortBy = sortByList.ReceivedOn;
    inboxPageStateObj1.orderBy = orderByList.ASC;
    inboxPageStateObj1.searchStatusFilter = statusFilter;
    setInboxPageState(inboxPageStateObj1);
    setSelectedAliasToShow("");
  };

  //get the fax based on Alias.
  const addRemoveAliasFiler = (e, child) => {
    if (e) {
      e.stopPropagation();
    }
    let tempAry = [...aliasSelectedFilter];
    let filterlength = tempAry.length;
    if (!child && e) {
      for (let i = 0; i < filterlength; i++) {
        if (e.target.checked && e.target.value == tempAry[i].alias) {
          tempAry[i].isChecked = true;
        } else if (e.target.value == tempAry[i].alias) {
          tempAry[i].isChecked = false;
        }
      }
    } else if (e == "") {
      for (let i = 0; i < filterlength; i++) {
        if (child.checked && child.value == tempAry[i].alias) {
          tempAry[i].isChecked = false;
        } else if (child.value == tempAry[i].alias) {
          tempAry[i].isChecked = true;
        }
      }
    }
    setAliasSelectedFilter([...tempAry]);
    if (tempAry?.length > 0) {
      let showAlias = "";
      let selectedAlias = tempAry?.filter((item) => {
        if (item.isChecked == true) {
          showAlias =
            (showAlias?.length > 0 ? showAlias + ", " : showAlias) + item.alias;
          return item;
        }
      });
      setSelectedAliasToShow(showAlias);
      setAliasCount(selectedAlias?.length);
    }
    //data filter by api
    let selectedAliaList = tempAry.filter((element) => {
      return element.isChecked == true;
    });
    let aliasStringList = selectedAliaList
      .map(function (element) {
        return element.alias;
      })
      .join(", ");

    getFaxList(
      aliasStringList ? aliasStringList : "null",
      searchVal ? searchVal : "null",
      faxIdSearchVal ? faxIdSearchVal : "null",
      1,
      sortBy,
      orderBy,
    );
    setSelectedPage(1);
    let inboxPageStateObj1 = inboxPageState;
    inboxPageStateObj1.pageNumber = 1;
    inboxPageStateObj1.searchCallerId = searchVal;
    inboxPageStateObj1.alias = selectedAliaList ? selectedAliaList : [];
    inboxPageStateObj1.sortBy = sortBy;
    inboxPageStateObj1.orderBy = orderBy;
    inboxPageStateObj1.searchStatusFilter = statusFilter;
    setInboxPageState(inboxPageStateObj1);
  };

  // View page called.
  const viewRecord = (row) => {
    history.push({
      pathname: "/viewpage",
      state: { pdfVal: row, indexPageState: inboxPageState },
    });
  };

  // View page for Child Fax called.
  const viewChildRecord = (parent, child, ind) => {
    history.push({
      pathname: "/viewpage",
      state: {
        parent: parent,
        child: child,
        ind: ind,
        indexPageState: inboxPageState,
      },
    });
  };

  // Process page Fax called.
  const processRecord = (row) => {
    history.push({
      pathname: "/processview",
      state: {
        pdfVal: row,
        indexPageState: { ...inboxPageState },
        faxId: row.FaxId,
      },
    });
  };

  // Drop down click toggle changes for child fax
  const childArrayClick = (pdf) => {
    if (openSplit == true && selectedRow !== pdf.Id) {
      setOpenSplit(true);
    } else {
      setOpenSplit(!openSplit);
    }
    setSelectedRow(pdf.Id);
    setChildPdfArray([...pdf.ChildPdf]);
    // setdeleteBtnPopup(false);
  };

  // Delete the child pdf and get refresh the fax.
  const childPdfDelete = (parentId, childId) => {
    if (parentId && childId) {
      axiosRequest
        .delete(
          `${process.env.REACT_APP_BaseUrl}fax/childfax/${parentId}/${childId}`,
        )
        .then((res) => {
          setdeleteBtnPopup(false);
          let childAray = childPdfArray;
          let index = childAray?.findIndex((elm) => elm.id == childId);
          if (index !== -1) {
            childAray?.splice(index, 1);
          }
          setChildPdfArray([...childAray]);
          if (childAray?.length == 0) {
            setOpenSplit(false);
            setSelectedRow("");
          }
          let alias = [...aliasSelectedFilter];
          alias = alias.filter((e) => {
            return e.isChecked == true;
          });
          let searchText = searchVal ? searchVal?.trim() : "null";
          let aliasStringList = alias
            ?.map(function (element) {
              return element.alias;
            })
            .join(", ");
          getFaxList(
            aliasStringList ? aliasStringList : "null",
            searchText,
            inboxPageState.searchFaxId || "null",
            selectedPage,
            sortBy,
            orderBy,
          );
        })
        .catch((err) => {
          console.log(err, "delete child pdf=====");
        });
    }
  };

  const processChildRecord = (parent, child) => {
    const enhancedChildPdf = {
      ...child,
      Id: child.id,
      FaxId: `${parent.FaxId}-${child.pages?.[0] || ""}`,
      parentId: parent.Id,
      isChildDocument: true,
      parentFaxId: parent.FaxId,
    };

    history.push({
      pathname: "/processview",
      state: {
        parent: parent,
        child: enhancedChildPdf,
        indexPageState: inboxPageState,
        isChildDocument: true,
        faxId: `${parent.FaxId}-${child.pages?.[0] || ""}`,
      },
    });
  };

  // On Idle the Fax list get Refreshed.
  const onIdle = () => {
    if (window?.location?.pathname == "/home") {
      let alias = [...aliasSelectedFilter];
      alias = alias.filter((e) => {
        return e.isChecked == true;
      });
      let searchText = searchVal ? searchVal?.trim() : "null";
      let aliasStringList = alias
        ?.map(function (element) {
          return element.alias;
        })
        .join(", ");
      getFaxList(
        aliasStringList ? aliasStringList : "null",
        searchText,
        inboxPageState.searchFaxId || "null",
        selectedPage,
        sortBy,
        orderBy,
      );
    }
  };
  // Toggle function for both label.
  const setOnClickToggleSort = (label) => {
    if (orderBy == orderByList.ASC) {
      sortByWithOrder(label, orderByList.DESC);
    } else {
      sortByWithOrder(label, orderByList.ASC);
    }
  };

  const getCurrentPageData = (currentPage, pageSize) => {
    // console.log(currentPage,pageSize,"ooooooooooo")
    let alias = [...aliasSelectedFilter];
    alias = alias.filter((e) => {
      return e.isChecked == true;
    });
    let searchText = searchVal ? searchVal?.trim() : "null";
    let aliasStringList = alias
      ?.map(function (element) {
        return element.alias;
      })
      .join(", ");
    getFaxList(
      aliasStringList ? aliasStringList : "null",
      searchText,
      inboxPageState.searchFaxId || "null",
      currentPage,
      sortBy,
      orderBy,
    );
    setSelectedPage(currentPage);
    let inboxPageStateObj1 = inboxPageState;
    inboxPageStateObj1.pageNumber = parseInt(currentPage);
    inboxPageStateObj1.searchCallerId = searchText;
    inboxPageStateObj1.alias = alias ? alias : [];
    inboxPageStateObj1.sortBy = sortBy;
    inboxPageStateObj1.orderBy = orderBy;
    inboxPageStateObj1.searchStatusFilter = statusFilter;
    setInboxPageState(inboxPageStateObj1);
  };

  const {
    start,
    reset,
    activate,
    pause,
    resume,
    isIdle,
    isPrompted,
    isLeader,
    getTabId,
    getRemainingTime,
    getElapsedTime,
    getLastIdleTime,
    getLastActiveTime,
    getTotalIdleTime,
    getTotalActiveTime,
  } = useIdleTimer({
    onIdle,
    timeout: 1000 * 60 * IdealTimeGetFaxCall,
    promptTimeout: 0,
    events: [
      "mousemove",
      "keydown",
      "wheel",
      "DOMMouseScroll",
      "mousewheel",
      "mousedown",
      "touchstart",
      "touchmove",
      "MSPointerDown",
      "MSPointerMove",
      "visibilitychange",
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 2000,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    name: "idle-timer",
    syncTimers: 0,
    leaderElection: false,
  });


  // Add this handler function
  const handleStatusChange = (event) => {
    const newStatus = event.target.value;
    setStatusFilter(newStatus);

    // Get current filter values from state
    const currentAlias = aliasSelectedFilter
      .filter((item) => item.isChecked)
      .map((item) => item.alias)
      .join(", ");

    // Trigger API call with all filters
    getFaxList(
      currentAlias || "null",
      searchVal || "null",
      faxIdSearchVal || "null",
      1,
      sortBy,
      orderBy,
      newStatus, // Include the new status
    );

    // Update page state
    setSelectedPage(1);

    // Use setInboxPageState instead of updateInboxPageState
    setInboxPageState({
      ...inboxPageState,
      pageNumber: 1,
      searchStatusFilter: newStatus,
      searchFaxId: faxIdSearchVal || "null",
    });
  };

  const getSuffix = (index, arrayLength) => {
    if (index === arrayLength - 1) return "END";
    if (index === 3 || index === 4) return "4";
    return (index + 1).toString();
  };

  const highlightSearchTerm = (text, searchTerm) => {
    if (!searchTerm || searchTerm.trim() === "" || !text) {
      return text;
    }

    const normalizedSearch = searchTerm.toLowerCase().trim();
    const normalizedSearchDigitsOnly = normalizedSearch.replace(/\D/g, "");

    if (
      normalizedSearchDigitsOnly.length >= 3 &&
      /^\d+$/.test(normalizedSearchDigitsOnly)
    ) {
      const textDigitsOnly = text.replace(/\D/g, "");

      if (textDigitsOnly.includes(normalizedSearchDigitsOnly)) {
        let searchPattern = normalizedSearchDigitsOnly.split("").join("\\D*");
        const regex = new RegExp(`(${searchPattern})`, "i");

        return text.replace(
          regex,
          '<span style="background-color: rgba(0, 171, 78, 0.2); padding: 0 2px;">$1</span>',
        );
      }
    }

    if (text.toLowerCase().includes(normalizedSearch)) {
      const regex = new RegExp(`(${normalizedSearch})`, "i");
      return text.replace(
        regex,
        '<span style="background-color: rgba(0, 171, 78, 0.2); padding: 0 2px;">$1</span>',
      );
    }

    return text;
  };

  const searchFaxRecord = (value) => {
    setFaxIdSearchVal(value);

    const numRegex = /^[0-9\b]+$/;
    if (!value || numRegex.test(value)) {
      setFaxIdValOnSearch(value);
    }
  };

  useEffect(() => {
    if (faxIdValOnSearch !== "null") {
      clearInterval(makeFaxIdAPIcall);
      setMakeFaxIdAPIcall(
        setTimeout(() => {
          searchFaxIdCall(faxIdSearchVal);
        }, 1000),
      );
    }
  }, [faxIdValOnSearch]);

  function searchFaxIdCall(enteredVal) {
    let searchText = enteredVal ? enteredVal?.trim() : "null";

    let alias = [...aliasSelectedFilter];
    alias = alias.filter((e) => e.isChecked == true);
    let aliasStringList = alias?.map((element) => element.alias).join(", ");

    const callerIdSearch = inboxPageState.searchCallerId || "null";

    setSelectedPage(1);
    let inboxPageStateObj1 = { ...inboxPageState };
    inboxPageStateObj1.searchFaxId = searchText;
    inboxPageStateObj1.pageNumber = 1;
    setInboxPageState(inboxPageStateObj1);

    getFaxList(
      aliasStringList ? aliasStringList : "null",
      callerIdSearch,
      searchText,
      1,
      sortBy,
      orderBy,
    );
  }

  // Define status configurations in a single object
  const STATUS_CONFIG = {
    NEW: {
      chipStyle: { bgcolor: "#FFF1D4", color: "#FFBB2A" },
      buttonText: "View",
      buttonStyle: { bgcolor: "#00AB4E" },
    },
    "IN-USE": {
      chipStyle: { bgcolor: "#CFEDFB", color: "#0EA5E9" },
      buttonText: "Resume",
      buttonStyle: { bgcolor: "#CFEDFB", color: "#0EA5E9" },
    },
    PROCESSING: {
      chipStyle: { bgcolor: "#CFEDFB", color: "#0EA5E9" },
      buttonText: "View",
      buttonStyle: { bgcolor: "grey.200", color: "text.primary" },
    },
    COMPLETED: {
      chipStyle: { bgcolor: "#CFF1E6", color: "#11B981" },
      buttonText: "View",
      buttonStyle: { bgcolor: "grey.200", color: "text.primary" },
    },
    SPLIT: {
      chipStyle: { bgcolor: "#FFF1D4", color: "#FFBB2A" },
      buttonText: "View",
      buttonStyle: { bgcolor: "#00AB4E" },
    },
    UPLOADING: {
      chipStyle: { bgcolor: "#F0E6FF", color: "#9061F9" },
      buttonText: "View.",
      buttonStyle: { bgcolor: "grey.200", color: "text.primary" },
    },
    UPLOADED: {
      chipStyle: { bgcolor: "#E6F6FF", color: "#0891B2" },
      buttonText: "View",
      buttonStyle: { bgcolor: "grey.200", color: "text.primary" },
    },
    UPLOAD_FAILED: {
      chipStyle: { bgcolor: "#FEE2E2", color: "#EF4444" },
      buttonText: "View",
      buttonStyle: { bgcolor: "grey.200", color: "text.primary" },
    },
    PROCESSING_TIMEOUT: {
      chipStyle: { bgcolor: "#FEF3C7", color: "#D97706" },
      buttonText: "View",
      buttonStyle: { bgcolor: "grey.200", color: "text.primary" },
    },
    PROCESSING_ERROR: {
      chipStyle: { bgcolor: "#FECACA", color: "#DC2626" },
      buttonText: "View",
      buttonStyle: { bgcolor: "grey.200", color: "text.primary" },
    },
    DEFAULT: {
      chipStyle: { bgcolor: "#F3F4F6", color: "#6B7280" },
      buttonText: "View",
      buttonStyle: { bgcolor: "grey.200", color: "text.primary" },
    },
  };

  // Map backend states to display states
  const STATE_MAPPING = {
    UPLOADING: "PROCESSING",
    UPLOADED: "PROCESSING",
    PROCESSING: "PROCESSING",
    READY: "SPLIT",
  };

  // Helper function to normalize and get config
  const getStatusConfig = (status) => {
    const normalized =
      typeof status === "string" ? status.toUpperCase() : status;

    // Apply state mapping if needed
    const displayState = STATE_MAPPING[normalized] || normalized;

    return STATUS_CONFIG[displayState] || STATUS_CONFIG.DEFAULT;
  };

  // Simplified components
  const StatusChip = ({ status }) => {
    const normalized =
      typeof status === "string" ? status.toUpperCase() : status;
    const displayStatus = STATE_MAPPING[normalized] || normalized;
    const { chipStyle } = getStatusConfig(status);

    // Format the display text with proper capitalization
    const formatDisplayText = (text) => {
      if (!text) return "";
      // Convert to lowercase and then capitalize first letter
      return text.toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
    };

    return (
      <Chip
        label={formatDisplayText(displayStatus)}
        size="small"
        sx={{
          borderRadius: "11px",
          // Removed textTransform as we're handling it manually
          "& .MuiChip-label": {
            px: 1.5,
          },
          ...chipStyle,
        }}
      />
    );
  };

  // First, let's fix the StatusButton component:
  const DISABLED_BUTTON_STATES = ["PROCESSING", "UPLOADED", "UPLOADING"];

  const StatusButton = ({
    status,
    onClick,
    variant = "contained",
    size = "small",
    sx = {},
  }) => {
    // Normalize the status first for consistency
    const normalizedStatus =
      typeof status === "string" ? status.toUpperCase() : status;

    // Get display status for button text
    const displayStatus = STATE_MAPPING[normalizedStatus] || normalizedStatus;
    const { buttonText, buttonStyle } = getStatusConfig(displayStatus);

    // Format the display text with proper capitalization if needed
    const formatDisplayText = (text) => {
      if (!text) return "";
      // Convert to lowercase and then capitalize first letter
      return text.toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
    };

    // Check against the original normalized status for disabled state
    const shouldBeDisabled = DISABLED_BUTTON_STATES.includes(normalizedStatus);

    return (
      <Button
        variant={variant}
        size={size}
        onClick={onClick}
        disabled={shouldBeDisabled}
        sx={{
          textTransform: "none",
          minWidth: "80px",
          ...buttonStyle,
          // Override styles when disabled (this is important)
          ...(shouldBeDisabled && {
            opacity: 0.7,
            // Ensure disabled styling is respected regardless of status color
            "&.Mui-disabled": {
              color: buttonStyle.color || "text.primary",
              backgroundColor: buttonStyle.bgcolor || "grey.200",
            },
          }),
          ...sx,
        }}
      >
        {buttonText}
      </Button>
    );
  };

  return (
    <>
      {cookies?.firstName ? (
        <>
          <Navbar />
          {/* Navigation and Search Header */}
          <Container
            maxWidth="2xl"
            sx={{ py: 1, pb: 4, backgroundColor: "#FaFaFa" }}
            style={{
              height: "100%",
              paddingRight: "2.5rem",
              paddingLeft: "2.5rem",
            }}
          >
            {/* Navigation Links */}
            <Stack direction="column" spacing={0.2} sx={{ mb: 4 }}>
              <Typography
                to="/"
                sx={{
                  textDecoration: "none",
                }}
                className="darkText"
              >
                Home
              </Typography>
              <Typography
                to="/order-list"
                sx={{
                  textDecoration: "none",
                  fontSize: "0.875rem",
                  color: "#9499A1",
                }}
              >
                Fax List
              </Typography>
            </Stack>

            <Container
              maxWidth="2xl"
              sx={{
                backgroundColor: "white",
                py: 4,
                px: 2,
                borderRadius: "10px",
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 5px",
              }}
            >
              {/* Search and Filter Section */}
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                sx={{ mb: 4 }}
                justifyContent="space-between"
              >
                <Box sx={{ display: "flex", gap: 2, flexGrow: 1 }}>
                  <TextField
                    placeholder="Search by Caller ID or Fax ID"
                    size="small"
                    fullWidth
                    value={combinedSearchVal}
                    onChange={(event) =>
                      handleCombinedSearch(event.target.value)
                    }
                    sx={{
                      maxWidth: 400,
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "background.paper",
                        "& fieldset": {
                          borderColor: "grey.200",
                        },
                      },
                    }}
                    className="darkText"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search sx={{ color: "text.secondary" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>

                <FormControl size="small" sx={{ minWidth: 200 }}>
                  <Select
                    value={statusFilter}
                    onChange={handleStatusChange}
                    displayEmpty
                    sx={{
                      color: statusFilter ? "#000" : "#9499A1",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#9499A1",
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#9499A1", // This changes the dropdown arrow color
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#9499A1", // Maintains color on hover
                      },
                    }}
                  >
                    <MenuItem className="darkText" value="">
                      All
                    </MenuItem>
                    <MenuItem className="darkText" value="New">
                      New
                    </MenuItem>
                    <MenuItem className="darkText" value="In-Use">
                      In-Use
                    </MenuItem>
                    <MenuItem className="darkText" value="Processing">
                      Processing
                    </MenuItem>
                    <MenuItem className="darkText" value="Completed">
                      Completed
                    </MenuItem>
                  </Select>
                </FormControl>
              </Stack>

              <hr />

              <TableContainer sx={{ mb: 4 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      {[
                        { id: "ReceivedOn", label: "DATE", sortable: true }, // Only date is sortable
                        { id: "Status", label: "STATUS", sortable: false },
                        { id: "FaxId", label: "FAX ID", sortable: false },
                        { id: "CallerId", label: "CALLER ID", sortable: false },
                        { id: "FaxLine", label: "FAX LINE", sortable: false },
                        { id: "Page", label: "PAGE", sortable: false },
                        { id: "Location", label: "LOCATION", sortable: false },
                        { id: "Alias", label: "ALIAS", sortable: false },
                        {
                          id: "ProcessedBy",
                          label: "PROCESSED BY",
                          sortable: false,
                        },
                        { id: "actions", label: "ACTIONS", sortable: false },
                      ].map((column) => (
                        <TableCell
                          key={column.id}
                          sx={{
                            color: "text.secondary",
                            fontSize: "0.75rem",
                            // fontWeight: 500,
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            borderBottom: "1px solid",
                            borderColor: "grey.200",
                            cursor: column.sortable ? "pointer" : "default",
                            // padding: "18px 8px",
                          }}
                          onClick={() => {
                            if (column.sortable) {
                              setOnClickToggleSort(column.id);
                            }
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5, // Add consistent spacing
                            }}
                          >
                            <span>{column.label}</span>
                            {column.sortable && (
                              <IconButton
                                size="small"
                                sx={{
                                  p: 0.5,
                                  color:
                                    sortBy === column.id
                                      ? "primary.main"
                                      : "grey.400",
                                  transition: "transform 0.2s",
                                  transform:
                                    orderBy === orderByList.DESC
                                      ? "rotate(180deg)"
                                      : "none",
                                }}
                              >
                                <BsArrowUp size={14} />
                              </IconButton>
                            )}
                          </Box>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {showData?.map((pdf, index) => (
                      <React.Fragment key={pdf.Id}>
                        {/* Parent Row */}
                        <TableRow
                          sx={{
                            "&:hover": { bgcolor: "grey.50" },
                            "& td": {
                              borderBottom: "1px dashed",
                              borderColor: "rgba(0, 0, 0, 0.08)",
                            },
                          }}
                        >
                          <TableCell>
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                            >
                              <Stack spacing={0}>
                                <Typography
                                  sx={{
                                    fontSize: "0.875rem",
                                  }}
                                  className="darkText"
                                >
                                  {/* Format: 10/24, 2024 */}
                                  {new Date(pdf.ReceivedOn)
                                    .toLocaleDateString("en-US", {
                                      month: "2-digit",
                                      day: "2-digit",
                                      year: "numeric",
                                    })
                                    .replace(
                                      /(\d{2})\/(\d{2})\/(\d{4})/,
                                      "$1/$2, $3"
                                    )}
                                </Typography>
                                <Typography
                                  sx={{
                                    color: "#9499A1",
                                    fontSize: "0.75rem",
                                  }}
                                >
                                  {/* Format: 4:15 PM */}
                                  {new Date(pdf.ReceivedOn).toLocaleTimeString(
                                    "en-US",
                                    {
                                      hour: "numeric",
                                      minute: "2-digit",
                                      hour12: true,
                                    }
                                  )}
                                </Typography>
                              </Stack>
                              {pdf?.ChildPdf?.length > 0 &&
                                pdf?.ChildPdf?.some((el) => !el?.deleted) && (
                                  <IconButton
                                    size="small"
                                    onClick={() => childArrayClick(pdf)}
                                    sx={{ p: 0, color: "text.secondary" }}
                                  >
                                    {openSplit && selectedRow === pdf.Id ? (
                                      <KeyboardArrowDown fontSize="small" />
                                    ) : (
                                      <KeyboardArrowRight fontSize="small" />
                                    )}
                                  </IconButton>
                                )}
                            </Stack>
                          </TableCell>
                          <TableCell>
                            {pdf?.ChildPdf?.length > 0 &&
                            pdf?.ChildPdf?.some((el) => !el?.deleted) ? (
                              <Chip
                                label="Source"
                                size="small"
                                sx={{
                                  borderRadius: "11px",
                                  "& .MuiChip-label": { px: 1.5 },
                                  bgcolor: "#CFEDFB",
                                  color: "#0EA5E9",
                                }}
                              />
                            ) : (
                              <StatusChip status={pdf.Status} />
                            )}
                          </TableCell>
                          <TableCell className="darkText">
                            {combinedSearchVal ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: highlightSearchTerm(
                                    isDemo
                                      ? pdf.FaxId +
                                          "UC" +
                                          getSuffix(index, showData.length)
                                      : pdf.FaxId,
                                    combinedSearchVal
                                  ),
                                }}
                              />
                            ) : isDemo ? (
                              pdf.FaxId +
                              "UC" +
                              getSuffix(index, showData.length)
                            ) : (
                              pdf.FaxId
                            )}
                          </TableCell>
                          <TableCell className="darkText">
                            {combinedSearchVal ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: highlightSearchTerm(
                                    pdf.CallerId,
                                    combinedSearchVal
                                  ),
                                }}
                              />
                            ) : (
                              pdf.CallerId
                            )}
                          </TableCell>
                          <TableCell className="darkText">
                            {pdf.FaxLine}
                          </TableCell>
                          <TableCell className="darkText">
                            {pdf.Pages}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: "#9499A1",
                            }}
                          >
                            {pdf.Name}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: "#9499A1",
                            }}
                          >
                            {pdf.Alias}
                          </TableCell>
                          <TableCell className="darkText">
                            {isDemo
                              ? cookies?.firstName + " " + cookies?.lastName
                              : pdf.ProcessedBy}
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" spacing={1}>
                              {pdf?.ChildPdf?.length > 0 ? (
                                <>
                                  {/* View Button */}
                                  <StatusButton
                                    status={pdf.Status}
                                    onClick={() => processRecord(pdf)}
                                  />
                                </>
                              ) : (
                                <StatusButton
                                  key={`status-btn-${pdf.Id}-${pdf.Status}`}
                                  status={pdf.Status}
                                  onClick={() =>
                                    !pdf?.ChildPdf?.length && processRecord(pdf)
                                  }
                                />
                              )}
                            </Stack>
                          </TableCell>
                        </TableRow>

                        {/* Child Rows */}
                        {openSplit &&
                          selectedRow === pdf.Id &&
                          childPdfArray?.map((el, ind) => {
                            if (!el.deleted) {
                              return (
                                <TableRow
                                  key={`child-${ind}`}
                                  sx={{
                                    bgcolor: "grey.50",
                                    "&:hover": { bgcolor: "grey.100" },
                                    "& td": {
                                      py: 1.5,
                                      borderBottom: "1px dashed",
                                      borderColor: "rgba(0, 0, 0, 0.08)",
                                    },
                                  }}
                                >
                                  <TableCell sx={{ pl: 2 }}>
                                    <Typography
                                      variant="body2"
                                      className="darkText"
                                      align="center"
                                    >
                                      {" "}
                                      {el?.pages && el.pages.length > 0
                                        ? `P${el.pages[0]}${
                                            el.pages.length > 1
                                              ? `-${
                                                  el.pages[el.pages.length - 1]
                                                }`
                                              : ""
                                          }`
                                        : ""}
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    <StatusChip
                                      status={pdf.ChildPdf[ind].status}
                                    />
                                  </TableCell>
                                  <TableCell className="darkText">
                                    {combinedSearchVal ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: highlightSearchTerm(
                                            `${pdf.FaxId}-${ind + 1}`,
                                            combinedSearchVal
                                          ),
                                        }}
                                      />
                                    ) : (
                                      `${pdf.FaxId}-${ind + 1}`
                                    )}
                                  </TableCell>
                                  <TableCell className="darkText">
                                    {combinedSearchVal ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: highlightSearchTerm(
                                            pdf.CallerId,
                                            combinedSearchVal
                                          ),
                                        }}
                                      />
                                    ) : (
                                      pdf.CallerId
                                    )}
                                  </TableCell>
                                  <TableCell className="darkText">
                                    {pdf.FaxLine}
                                  </TableCell>
                                  <TableCell className="darkText">
                                    {el?.pages?.length}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      color: "#9499A1",
                                    }}
                                  >
                                    {pdf.Name}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      color: "#9499A1",
                                    }}
                                  >
                                    {pdf.Alias}
                                  </TableCell>
                                  <TableCell className="darkText">
                                  {isDemo
                              ? cookies?.firstName + " " + cookies?.lastName
                              : el.processed_by || pdf.ProcessedBy}
                                  </TableCell>

                                  <TableCell>
                                    <Stack direction="row" spacing={1}>
                                      {/* Process/Add/Resume Button */}
                                      <StatusButton
                                        key={`child-status-btn-${el.id}-${el.status}`}
                                        status={pdf.ChildPdf[ind].status}
                                        onClick={() =>
                                          processChildRecord(pdf, el)
                                        }
                                      />
                                      {/* Delete Button */}
                                      {!DISABLED_BUTTON_STATES.includes(
                                        (
                                          pdf.ChildPdf[ind].status || ""
                                        ).toUpperCase()
                                      ) && (
                                        <IconButton
                                          size="small"
                                          disabled={DISABLED_BUTTON_STATES.includes(
                                            (
                                              pdf.ChildPdf[ind].status || ""
                                            ).toUpperCase()
                                          )}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedChildForDeletion(el.id);
                                            setdeleteBtnPopup(true);
                                            setafterfDeleteChangePopup(false);
                                          }}
                                          sx={{
                                            color: "error.main",
                                            "&:hover": {
                                              bgcolor: "error.lighter",
                                            },
                                            "& .default-icon": {
                                              display: "block",
                                            },
                                            "& .hover-icon": {
                                              display: "none",
                                            },
                                            "&:hover .default-icon": {
                                              display: "none",
                                            },
                                            "&:hover .hover-icon": {
                                              display: "block",
                                            },
                                          }}
                                        >
                                          <TrashIcon
                                            className="default-icon"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                            }}
                                          />
                                          <TrashIconHover
                                            className="hover-icon"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                            }}
                                          />
                                        </IconButton>
                                      )}
                                    </Stack>

                                    {/* Delete Confirmation Dialog */}
                                    <Dialog
                                      open={deleteBtnPopup}
                                      onClose={() => {
                                        setafterfDeleteChangePopup(false);
                                        setdeleteBtnPopup(false);
                                        setSelectedChildForDeletion(null);
                                      }}
                                      PaperProps={{
                                        sx: {
                                          borderRadius: 1,
                                        },
                                      }}
                                    >
                                      <DialogTitle>
                                        {afterfDeleteChangePopup
                                          ? "Success"
                                          : "Are you sure you want to delete this document?"}
                                      </DialogTitle>
                                      <DialogContent>
                                        {afterfDeleteChangePopup ? (
                                          <Typography>
                                            Deleted successfully
                                          </Typography>
                                        ) : (
                                          <Typography>
                                            This document will be deleted
                                            immediately. You can't undo this
                                            action.
                                          </Typography>
                                        )}
                                      </DialogContent>
                                      <DialogActions>
                                        {!afterfDeleteChangePopup && (
                                          <>
                                            <Button
                                              onClick={() => {
                                                setafterfDeleteChangePopup(
                                                  false
                                                );
                                                setdeleteBtnPopup(false);
                                              }}
                                              sx={{ color: "text.secondary" }}
                                            >
                                              Cancel
                                            </Button>
                                            <Button
                                              onClick={() =>
                                                childPdfDelete(
                                                  pdf?.Id,
                                                  selectedChildForDeletion
                                                )
                                              }
                                              variant="contained"
                                              sx={{
                                                backgroundColor: "#00AB4E",
                                                color: "#FFFFFF",
                                                fontFamily: "Manrope",
                                                "&:hover": {
                                                  backgroundColor: "#009245",
                                                },
                                              }}
                                            >
                                              Delete
                                            </Button>
                                          </>
                                        )}
                                      </DialogActions>
                                    </Dialog>
                                  </TableCell>
                                </TableRow>
                              );
                            }
                            return null;
                          })}
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ mt: 3, px: 2 }}
              >
                {/* Showing entries text */}
                <Typography variant="body2" color="text.secondary">
                  Showing{" "}
                  {Math.min(
                    (selectedPage - 1) * backendPageSize + 1,
                    totalElements
                  )}{" "}
                  - {Math.min(selectedPage * backendPageSize, totalElements)} of{" "}
                  {totalElements}
                </Typography>

                {/* Simplified pagination */}
                {showData?.length > 0 && (
                  <CustomPagination
                    totalCount={totalElements}
                    showPages={0}
                    pagesArray={0}
                    pageSize={backendPageSize}
                    currentPage={selectedPage}
                    getCurrentPageData={getCurrentPageData}
                    setTotalPages={setTotalPages}
                    show={true}
                  />
                )}
              </Stack>

              <DocumentStatusMonitor
                showData={showData}
                setShowData={setShowData}
              />
            </Container>
          </Container>
        </>
      ) : null}
    </>
  );
};
export default HomePage;
